/**
 * Which local tables sync, under which remote names — and the exact bytes a
 * row goes up as. Shared by the sync engine (`sync.ts`) and the native outbox
 * mirror (`outbox_middleware.ts`), so the two can never send different
 * payloads for the same write: the native uploader may push a row the app
 * pushes again later, and the server deduplicates on `updated_at`, not on luck
 * (DATA_MODEL §5.4).
 *
 * Its own module because `db.ts` registers the outbox middleware and must not
 * import `sync.ts`, which imports `db.ts`.
 */

/** Dexie table name → remote `table_name`, for every synced table. */
export const SYNCED_TABLES: Readonly<Record<string, string>> = {
  profile: "profile",
  categories: "categories",
  budgets: "budgets",
  salaries: "salaries",
  recurringRules: "recurring_rules",
  expenses: "expenses",
  soundings: "soundings",
  soundingActions: "sounding_actions",
  splitGroups: "split_groups",
  splitExpenses: "split_expenses",
  splitTransfers: "split_transfers",
};

/**
 * A local row as it travels: sync bookkeeping stripped (it means nothing to
 * any other device), and fields a newer client wrote that this one does not
 * know (`_extra`) put back first, so a known field always wins over a stale
 * copy of itself.
 */
export function toWirePayload(row: object): string {
  const domain = { ...row } as Record<string, unknown>;
  delete domain._dirty;
  delete domain._syncedAt;
  const extra = (domain._extra ?? {}) as Record<string, unknown>;
  delete domain._extra;
  const payload = { ...extra, ...domain };
  delete payload._moveFrom;
  delete payload._createdBy;
  delete payload._updatedBy;
  return JSON.stringify(payload);
}
